import { IFlowEventData } from 'types/analytics';

export const TEXT_KEYS = {
    GAME_NAME: 'gameName',
    PLATFORM_SELECTION_TITLE: 'platform-selection__title'
};

export const SET_PLATFORM = 'SET_PLATFORM';

export const PLATFORM_URL_PARAMETER = 'platform';

export const PLATFORM_BUTTON_FLOW_ACTION = (platform: string, isConsole: boolean = false): Partial<IFlowEventData> => ({
    action: `platform ${platform} selected`,
    platformSelection: isConsole ? platform : ''
});
